import { LocalStore } from 'constants/localstore';
import { useStoreProject } from './hooks/use-project';
import { useActions } from './hooks/use-actions';
import { useApi } from './hooks/use-api';

export const useLocalstoreSignOut = () => {
  const { storeProject } = useStoreProject();
  const { storeActions } = useActions();
  const { storeApi } = useApi();

  const localstoreSignOut = () => {
    storeApi();
    storeProject();
    storeActions();
    localStorage.removeItem(LocalStore.token);
  };
  return { localstoreSignOut };
};
